module.exports = __webpack_public_path__ + "img/walkingCouple.37700d0d.svg";